if (!customElements.get("builder-add-to-cart")) {
  customElements.define(
    "builder-add-to-cart",
    class BuilderAddToCart extends HTMLElement {
      constructor() {
        super();

        this.submitButton = this.querySelector(
          '[data-action="cabinet-add-to-cart"]'
        );
        this.submitButton.addEventListener(
          "click",
          this.onSubmitHandler.bind(this)
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.classList.contains("loading")) return;
        document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.setAttribute("disabled", "");
        this.submitButton.classList.add("loading");
        const qtyInput = this.querySelector(
          'input[name="quantity"]:not(.tw-hidden)'
        );
        const variantId = qtyInput.dataset.variantId.split("-")[0];
        var doorStyle = localStorage.getItem("builder:doorStyle");
        var doorColor = localStorage.getItem("builder:doorColor");
        var cabinetColor = localStorage.getItem("builder:cabinet colour");
        var cabinetDrawerColor = localStorage.getItem("builder:drawer color");
        var cabinetHinges = localStorage.getItem("builder:hinges");
        var cabinetHingeType = localStorage.getItem("builder:hinge type");
        var hingsslide = $(".hinge-side-select-js").val();
        //  document.getElementsByClassName("mini-cart__button-container").style.visibility = "hidden";

        var reqBody = {
          updates: {
            [variantId]: parseInt(qtyInput.value),
          },
          properties: {
            "Hinge Side": hingsslide,
          },
          attributes: {
            "Cabinet Colors": cabinetColor,
            Hings: cabinetHinges,
            "hings type": cabinetHingeType,
            "Drawer colour": cabinetDrawerColor,
            "Door color": doorColor,
            "Door style": doorStyle,
          },
        };

        console.log(reqBody);
        fetch(window.routes.rootUrl + "cart/update.js", {
          body: JSON.stringify(reqBody),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            document.documentElement.dispatchEvent(
              new CustomEvent("product:added", { bubbles: true })
            );

            setTimeout(function () {
              document.querySelector(
                ".mini-cart__button-container"
              ).style.display = "none";
              console.log("Kalpesh2");
            }, 400);
            $("#raqs-quickview").removeClass("raqs-opened");
            // $('.mini-cart__button-container').hide();
            $("#raqs-quickview").hide();
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              2000
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.removeAttribute("disabled");

            document.dispatchEvent(new CustomEvent("theme:loading:end"));
          });
        //   console.log("Kalpesh");
        //
      }

      handleErrorMessage(errorMessage = false) {
        var messageElement = document.createElement("div");
        messageElement.className = "product-form__status-message";
        messageElement.innerHTML = '<p class="alert '
          .concat("alert--error", '">')
          .concat(errorMessage, "</p>");
        this.append(messageElement);
        setTimeout(function () {
          messageElement.remove();
        }, 3000);
      }
    }
  );
}
